/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnInit, OnChanges} from '@angular/core';
import {ServerObjectService} from "../../services/server-object.service";
import {ServiceService} from "../../services/service.service";
import {ServerObjectInstance} from "../../models/server-object-instance";
import {NgxSpinnerService} from "ngx-spinner";

declare var $: any;

@Component({
  selector: 'app-settings-user',
  templateUrl: './settings.user.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsUserComponent implements OnInit, OnChanges {
  @Input() userLockout;
  serverObjectInstance: ServerObjectInstance;

  max_login_attempts: number;
  locked_time: number;

  constructor(private services: ServiceService, private serverObjectService: ServerObjectService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.userLockout) {
      console.log("user_lockout id is " + this.userLockout.id);

      this.serverObjectService.getServerObjectInstanceById(this.userLockout.id).then(
        response => {
          this.serverObjectInstance = response;
          this.setUserLockoutSettings();
        },
        error => {
          console.log("Could not get user_lockout instance: " + error);
        });
    }
  }

  private setUserLockoutSettings(): void {
    if (this.serverObjectInstance.data && this.serverObjectInstance.data.length > 0) {
      for(const data of this.serverObjectInstance.data) {
        switch(data.property.property) {
          case "max_login_attempts" : case "locked_time" :
          this[data.property.property] = Number(data.value);
          break;
        }
      }
    }
  }

  public updateSettingsLockout(): void {
    this.spinner.show();

    console.log("updateSettingsLockout()");
    if (this.serverObjectInstance.data && this.serverObjectInstance.data.length > 0) {
      for(const data of this.serverObjectInstance.data) {
        switch(data.property.property) {
          case "max_login_attempts" : case "locked_time" :
            data.value = "" + this[data.property.property];
            data.object_value = this[data.property.property];
          break;
        }
      }
    }

    this.serverObjectService.updateServerObjectInstance(this.serverObjectInstance)
      .then(
        response => {
          this.spinner.hide();
          console.log("update UserLockout Instance successful");
        },
        error => {
          this.spinner.hide();
          console.log("Error updating UserLockout Instance: " + error);
          const response: Response = error;
          alert(response.text());
        }
      );

  }

}
